import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as planApi from '../Api/planApi';

const PLAN_KEY = 'plans';

// Get all plans
export const usePlans = (options = {}) => {
	const { includeInactive = false, ...queryOptions } = options;

	return useQuery({
		queryKey: [PLAN_KEY, { includeInactive }],
		queryFn: async () => {
			const result = await planApi.getPlans({ includeInactive });
			return result?.data?.data || [];
		},
		staleTime: 5 * 60 * 1000,
		...queryOptions,
	});
};

// Get a single plan by ID
export const usePlan = (id) =>
	useQuery({
		queryKey: [PLAN_KEY, id],
		queryFn: () => planApi.getPlan(id),
		enabled: !!id,
	});

// Create a new plan
export const useCreatePlan = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: planApi.createPlan,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [PLAN_KEY] });
		},
	});
};

// Update a plan
export const useUpdatePlan = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, planData }) => planApi.updatePlan(id, planData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [PLAN_KEY] });
		},
	});
};

// Delete a plan
export const useDeletePlan = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (id) => planApi.deletePlan(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [PLAN_KEY] });
		},
	});
};
